// LogoutButton.jsx - Versión Mejorada
import React from "react";
import PropTypes from "prop-types";
import { useAuth } from "app/providers/authContext";
import MDButton from "shared/components/MDButton";
import Icon from "@mui/material/Icon";
import { IconButton, Tooltip } from "@mui/material";

const LogoutButton = ({ iconOnly = false, size = "medium" }) => {
  const { logout } = useAuth();

  if (iconOnly) {
    return (
      <Tooltip title="Cerrar Sesión" placement="right" enterDelay={300}>
        <IconButton
          onClick={logout}
          color="error"
          size={size}
          sx={{
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            animation: "pulse 2s infinite",
            "&:hover": {
              transform: "scale(1.15)",
              backgroundColor: "error.main",
              color: "white",
              animation: "none",
            },
            "@keyframes pulse": {
              "0%": { opacity: 1 },
              "50%": { opacity: 0.6 },
              "100%": { opacity: 1 },
            },
          }}
        >
          <Icon>power_settings_new</Icon>
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <MDButton
      variant="gradient"
      color="error"
      onClick={logout}
      fullWidth
      startIcon={<Icon>logout</Icon>}
      sx={{
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-2px) scale(1.02)",
          boxShadow: 4,
        },
      }}
    >
      Cerrar Sesión
    </MDButton>
  );
};

LogoutButton.propTypes = {
  iconOnly: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

LogoutButton.defaultProps = {
  iconOnly: false,
  size: "medium",
};

export default LogoutButton;
